import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementTransactionsService {
  constructor(private api: ApiService) {}

  getPortalTransactions(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 100,
        offset: 0,
        q: '',
        filter: []
      };
    }

    return this.api.getAPI('portal/management/transactions', queryParams).pipe(
      map((res: any) => {
        return res.body;
      })
    );
  }

  getPortalTransactionsBySubscriptionId(portal_subscription_id: number) {
    return this.api
      .getAPI(`portal/management/subscriptions/${portal_subscription_id}/transactions`)
      .pipe(
        map((res: any) => {
          return res.body.data;
        })
      );
  }

  overrideTransactionPaymentMethod(transaction: any, portal_transaction_id: number) {
    return this.api
      .postAPI(`portal/management/transactions/${portal_transaction_id}/override`, transaction)
      .pipe(
        map((res: any) => {
          return res.body;
        })
      );
  }

  voidTransaction(portal_transaction_id: number) {
    return this.api
      .postAPI(`portal/management/transactions/${portal_transaction_id}/void`, {})
      .pipe(
        map((res: any) => {
          return res.body;
        })
      );
  }
}
